if(document.querySelectorAll('.stl-wrap')) document.querySelectorAll('.stl-wrap').forEach(function(dotWrapper){
  dotWrapper.querySelectorAll('.stl-dot').forEach(function(dot){
    dot.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let thisHandle = dot.getAttribute('data-handle');
      if(dot.classList.contains('active-dot')){
        dot.classList.remove('active-dot');
      }else{
        dotWrapper.querySelectorAll('.stl-dot').forEach(function(dotRemove){
          dotRemove.classList.remove('active-dot');
        });
        dot.classList.add('active-dot');
      }
      dotWrapper.querySelectorAll('.stl-prod-media-list li').forEach(function(media){
        let mediaHandle = media.getAttribute('data-handle');
        if(mediaHandle == thisHandle){
          if(media.classList.contains('active-media')){
            media.classList.remove('active-media');
          }else{
            dotWrapper.querySelectorAll('.stl-prod-media-list li').forEach(function(mediaRemove){
              mediaRemove.classList.remove('active-media');
            });
            media.classList.add('active-media');
          }
        }
      });
      dotWrapper.querySelectorAll('.stl-prod-meta-list li').forEach(function(meta){
        let metaHandle = meta.getAttribute('data-handle');
        if(metaHandle == thisHandle){
          if(meta.classList.contains('active-meta')){
            meta.classList.remove('active-meta');
          }else{
            dotWrapper.querySelectorAll('.stl-prod-meta-list li').forEach(function(metaRemove){
              metaRemove.classList.remove('active-meta');
            });
            meta.classList.add('active-meta');
          }
        }
      });
    });
  });
});
const sections = document.querySelectorAll('.section-shop-the-look');
sections.forEach(section => {
  const swiperWrappers = section.querySelectorAll('.stl-media .swiper-wrapper');
  let loopCount = 0;
  let inViewport = false;
  let loopTimeout1, loopTimeout2, loopTimeout3;
  let animationRunning = false;
  function isEntered80PercentViewport(el) {
    const rect = el.getBoundingClientRect();
    const triggerPoint = window.innerHeight * 0.2;
    return rect.top <= triggerPoint && rect.bottom >= 0;
  }
  function setLeftAndClass(value){
    swiperWrappers.forEach(wrapper => {
      const activeSlide = wrapper.querySelector('.swiper-slide-active');
      const lastSlide = wrapper.querySelector('.swiper-slide:last-child');
      if (activeSlide && lastSlide && activeSlide === lastSlide) return;
      wrapper.style.left = value;
    });
    if (value === '-30%') {
      section.classList.add('in-viewport');
    } else {
      setTimeout(() => section.classList.remove('in-viewport'), 1000);
    }
  }
  function resetAnimation() {
    setLeftAndClass('0px');
    if (window.mySwiperInstance) {
      window.mySwiperInstance.slideTo(0);
    }
    clearTimeout(loopTimeout1);
    clearTimeout(loopTimeout2);
    clearTimeout(loopTimeout3);
    animationRunning = false;
  }
  function triggerAnimationCycle() {
    if (loopCount >= 2 || animationRunning) return;
    animationRunning = true;
    setLeftAndClass('-30%');
    loopCount++;
    loopTimeout1 = setTimeout(() => {
      setLeftAndClass('0px');
      animationRunning = false;
    }, 1000);
  }
  if (isEntered80PercentViewport(section) && loopCount < 2) {
    inViewport = true;
    triggerAnimationCycle();
  }
  window.addEventListener('scroll', () => {
    const nowInView = isEntered80PercentViewport(section);
    if (nowInView && !inViewport && loopCount < 2){
      inViewport = true;
      triggerAnimationCycle();
    } else if (!nowInView && inViewport){
      inViewport = false;
      resetAnimation();
    }
  });
});
let init = false;
let swiperInstances = [];
function updateActiveMeta(swiperEl) {
  const activeSlide = swiperEl.el.querySelector('.swiper-slide-active');
  if (!activeSlide) return;
  const activeHandle = activeSlide.getAttribute('data-handle');
  const stlWrap = swiperEl.el.closest('.stl-wrap');
  const metaItems = stlWrap.querySelectorAll('.stl-prod-meta-list li');
  let matched = false;
  metaItems.forEach((item) => {
    if (item.getAttribute('data-handle') === activeHandle) {
      item.classList.add('active-meta');
      matched = true;
    } else {
      item.classList.remove('active-meta');
    }
  });
  if (!matched) {
    metaItems.forEach((item) => item.classList.remove('active-meta'));
  }
}
function swiperCard() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
      swiperInstances = [];
      document.querySelectorAll('.stl-wrap').forEach(section => {
        const swiperEl = section.querySelector('.stl-media');
        if (!swiperEl) return;
        const swiper = new Swiper(swiperEl, {
          slidesPerView: "auto",
          loop: false,
          resizeObserver: false,
          on: {
            init() {
              updateActiveMeta(this);
            },
            slideChangeTransitionEnd() {
              updateActiveMeta(this);
            }
          }
        });
        swiperInstances.push({ section, swiper });
        section.querySelectorAll('.stl-prod-meta-list li').forEach((stl_list, index) => {
          stl_list.addEventListener('click', function (e) {
            if (!stl_list.classList.contains('redirect_to')) {
              e.preventDefault();
              let i = index + 1;
              swiper.slideTo(i);
              stl_list.classList.add('redirect_to');
            }
          });
        });
      });
    }
  } else if (init) {
    swiperInstances.forEach(({ swiper }) => swiper.destroy());
    swiperInstances = [];
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);